// extracted by mini-css-extract-plugin
export default {"label":"ActionLabel_label__dYNxD"};